export default [
    {
        path: '/partners-spends',
        name: 'PagePartnersSpendsList',
        meta: { title: 'partnersSpendsTable.listTitle', roles: ['ADMIN', 'TEAM_LEADER'], permissions: ['partners_spend_view'] },
        component: () => import('@/pages/partners-spends'),
    },
]